import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusShellActions], campus-shell-actions',
})
export class ShellActionsDirective {
  @HostBinding('class.ui-shell__actions') hasShellActionClass = true;
}
